/** 提示文本、灰色文本、蓝色提示文字 */
import getters from "./getters";

export default {
  namespaced: true,
  name: "hintText",
  state: {
    hintText: {},
  },
  mutations: {
    SET_HINTTEXT(state, value) {
      state.hintText = value;
    },
  },
  getters,
};
